module.exports = __webpack_public_path__ + "static/media/reachcustomermain3.d8b6d252.png";